export const FRONTEND_STATE_SELECT_LOCATION_START = 'FRONTEND_STATE_SELECT_LOCATION_START';
export const FRONTEND_STATE_SELECT_LOCATION_STOP = 'FRONTEND_STATE_SELECT_LOCATION_STOP';
export const FRONTEND_STATE_SELECT_LOCATION_SET_ADDRESS_LOADING = 'FRONTEND_STATE_SELECT_LOCATION_SET_ADDRESS_LOADING';
